export default function AboutUs() {
  return (
    <section className="section">
      <div className="container">
        <h2>Leistungen</h2>
        <div className="grid">
          <article className="card">
            <h3>Firmen & Vereine</h3>
            <p>Bestickte Arbeitskleidung, Teamwear und Werbemittel – langlebig und edel.</p>
          </article>
          <article className="card">
            <h3>Personalisierung</h3>
            <p>Namen, Initialen oder Motive für Geschenke mit persönlicher Note.</p>
          </article>
          <article className="card">
            <h3>Kleinstserien und individuelle Einzelanfertigungen</h3>
            <p>Aufträge ab kleiner Stückzahl – ideal für besondere Anlässe.</p>
          </article>
        </div>
      </div>
    </section>
  );
}
